const common = {
  'brand': 'USFans Spreadsheet',
  'nav.home': 'Accueil',
  'nav.shoppingGuide': "Guide d'achat",
  'nav.categories': 'Catégories',
  'nav.guides': 'Guides',
  'nav.reviews': 'Avis',
  'nav.safety': 'Sécurité',
  'nav.cta': 'Acheter Maintenant',
  'common.readMore': 'Lire la suite',
  'common.updated': 'Mis à jour',
  'common.mainSite': 'Visiter le site principal',
  'common.backHome': 'Retour à l\'accueil',
  'footer.tagline': 'Un centre de ressources indépendant qui vous aide à organiser les ressources de la feuille de calcul USFans, les listes de produits, les informations sur les vendeurs et les guides d\'achat au même endroit.',
  'footer.navTitle': 'Navigation',
  'footer.resourcesTitle': 'Ressources',
  'footer.categories': 'Catégories',
  'footer.guides': 'Guides',
  'footer.reviews': 'Avis',
  'footer.safety': 'Centre de sécurité',
  'footer.disclaimer': 'Ce site web est une ressource informative indépendante. Vérifiez toujours de manière indépendante les sites web, les vendeurs, les liens, les prix et les détails des transactions avant d\'agir.',
  'footer.rights': 'Tous droits réservés.',
  'lang.english': 'English',
  'lang.polish': 'Polski',
  'lang.spanish': 'Español',
  'lang.french': 'Français',
};

export default common;